import * as React from 'react';
import { FC } from 'react';

import { useEnablePullToReloadOnScroll } from 'components/pull-to-reload';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import { useLoyaltyContext } from 'state/loyalty';

import { LoyaltyBackground } from '../loyalty-background';
import { LoyaltyPullToReload } from '../loyalty-pull-to-reload';

import {
  HistoryContainer,
  RefreshContainer,
  StyledLoyaltyClaimPointsLink,
  StyledLoyaltyNoRewardPoints,
} from './loyalty-history.styled';

/**
 *
 * Loyalty History view container for RBI Loyalty Program
 * Displays tables with loyalty transaction history
 *
 */
const LoyaltyHistory: FC = () => {
  const { claimPointsEnabled } = useLoyaltyContext();
  const {
    getScrollPositionForReload,
    pullToReloadEnabled,
    setScrollRef,
  } = useEnablePullToReloadOnScroll();

  const isMobileSizedDevice = useMediaQuery(MediaQuery.Mobile);

  return (
    <LoyaltyBackground
      fullHeight
      scroll
      onScroll={getScrollPositionForReload}
      ref={setScrollRef}
      constrainToViewHeight={isMobileSizedDevice}
    >
      <RefreshContainer>
        <LoyaltyPullToReload onRefresh={() => Promise.resolve()} enabled={pullToReloadEnabled}>
          <HistoryContainer>
            <StyledLoyaltyNoRewardPoints />
            {claimPointsEnabled && <StyledLoyaltyClaimPointsLink renderAsButton />}
          </HistoryContainer>
        </LoyaltyPullToReload>
      </RefreshContainer>
    </LoyaltyBackground>
  );
};

export default LoyaltyHistory;
